import classnames from 'classnames/bind';
import style from './questionDndItem.module.scss';
import React from 'react';
import { Draggable } from 'react-beautiful-dnd';
import { QuestionType } from '@domain/constant/questionType';
import { JobTypeCode } from '@domain/constant/v1/jobType';
import { useJobGroupList } from '@repository/codes/useCodes';
import { useInterview, InterviewQuestionType } from '@components/pass/interview/start/context/interviewContext';
import { CompanyQuestionVO } from '@domain/vo/pass/interview/question/CompanyQuestionVO';
import { PooledAccQuestionDto } from '@domain/rs/pass/interview/question/PooledAccQuestionListRs';

const cx = classnames.bind(style);

interface QuestionDndItemProps {
  index: number;
  data: InterviewQuestionType;
}

const InterviewPracticeQuestionDndItem = ({ index, data }: QuestionDndItemProps) => {
  const { updateSelectedQuestionList } = useInterview();
  const { type: questionType, sn: questionId } = data;
  const { data: jobGroupData } = useJobGroupList();
  const jobGroupList = jobGroupData?.jobTitleGroups;

  const handleDeleteClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    updateSelectedQuestionList(data);
  };

  const sectionName = () => {
    switch (questionType) {
      case QuestionType.COMPANY:
        return (data as CompanyQuestionVO).companyName;
      case QuestionType.FREQUENCY:
        return '빈출 면접 질문';
      case QuestionType.MYSELF:
        return '내가 만든 질문';
      default:
        return '역량검사 결과 기반 질문';
    }
  };

  const sectionNameClass = () => {
    switch (questionType) {
      case QuestionType.COMPANY:
        return 'sectionNameCompany';
      case QuestionType.FREQUENCY:
        return 'sectionNameFrequency';
      case QuestionType.MYSELF:
        return 'sectionNameMyself';
      default:
        return 'sectionNameAcc';
    }
  };

  const jobType = () => {
    if (!(data instanceof CompanyQuestionVO)) return '';

    switch (data.jobTypeCode) {
      case JobTypeCode.NEW:
        return '신입';
      case JobTypeCode.CAREER:
        return '경력';
      case JobTypeCode.INTERNSHIP:
        return '인턴';
      default:
        return '';
    }
  };

  const jobGroup = () => {
    if (!(data instanceof CompanyQuestionVO)) return '';

    if (jobGroupList) {
      if (data.jobGroupCode === -1) {
        return '직군 공통';
      } else {
        const idx = jobGroupList.findIndex((it) => it.code === data.jobGroupCode);
        if (idx !== -1) {
          return jobGroupList[idx].name;
        }
      }
    }

    return '';
  };

  const jobTypeResult = jobType();
  const jobGroupResult = jobGroup();

  return (
    <Draggable draggableId={`question-${questionId}`} index={index}>
      {(provided) => (
        <li
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          ref={provided.innerRef}
          key={questionId}
          className={cx('questionItem')}
        >
          <div className={cx('questionItemInner', sectionNameClass())}>
            <div className={cx('sectionTag')}>
              <div className={cx('tag', 'sectionName', sectionNameClass())}>{sectionName()}</div>
              {jobTypeResult && <div className={cx('tag')}>{jobType()}</div>}
              {jobGroupResult && <div className={cx('tag')}>{jobGroup()}</div>}
              {sectionNameClass() === 'sectionNameAcc' && (
                <>
                  <div className={cx('tag')}>{data.type === 'WEAKNESS' ? '약점' : '강점'}</div>
                  <div className={cx('tag')}>{(data as PooledAccQuestionDto).description}</div>
                </>
              )}
            </div>
            <div className={cx('description')}>
              <span className={cx('intro')}>Q.</span>
              <span className={cx('question')}>{data.questionText}</span>
            </div>
          </div>
          <button className={cx('btnDelete')} onClick={handleDeleteClick} />
        </li>
      )}
    </Draggable>
  );
};

export default InterviewPracticeQuestionDndItem;
